<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/plan/stay'">
      <ZuiHeader/>
      <SubPageTemplate page-title="住得舒适" dynamically-tab :pid="$cid.play.zhudeShuShi" :default-tab-id="tabId"
                       :page-size="5" type="article" :video-mask="false" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/plan/stay/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/plan/stay.vue